import { IFirmsResponse } from 'CommonTypes/Firms/Firms';
import { oldApi } from 'Config/path.js';
import { fetchGet } from 'Services/fetchService.js';

export default async () => {
    const response: IFirmsResponse[] = await fetchGet(`${oldApi}/contragents_all.php?mode=firm`);
    return response;
};
